// extracted by mini-css-extract-plugin
export default {"verifiedAccountTitle":"_1FZVj","socialIconsDark":"_2WeRm","socialIconsLight":"_3jImC","icon":"_2ipDj"};